// extracted by mini-css-extract-plugin
module.exports = {"back_layout":"app_back_layout__1kn2N","top_layout":"app_top_layout__2DlEJ"};